import { ProcessTalentResponseDTO, ProcessTalentResponseDTOStatus } from '@/api/generated';

import { isComplete, isInProgress, isRefused } from './testSessions';

export const isProcessBusy = (process: ProcessTalentResponseDTO) => {
  const testSessionSummaries = process.testSessionSummaries ?? [];

  return (
    process.status === ProcessTalentResponseDTOStatus.CANCELLED ||
    process.status === ProcessTalentResponseDTOStatus.COMPLETED ||
    testSessionSummaries.some(session => isInProgress(session) || isRefused(session) || isComplete(session))
  );
};
